<template>
  <v-row>
    <v-col cols="4">
      <metric-kpi metric="total_receivables_current_due" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="total_receivables_overdue" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="total_receivables" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="6">
      <metric-table metric="overdue_billing_recovery_breakdown" />
    </v-col>
    <v-col cols="6">
      <metric-table metric="customer_debtor" />
    </v-col>

    <!-- payments -->
    <v-col cols="12" class="px-0 pb-0">
      <v-toolbar color="transparent" flat height="55" dense>
        <v-toolbar-title class="pa-0 ml-n1 text--secondary subtitle-1 font-weight-medium">Pagos</v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="6">
      <metric-graph metric="total_payments" />
    </v-col>
    <v-col cols="6">
      <metric-graph metric="transactions_received_by_gateway" />
    </v-col>
    <!-- end payments -->
  </v-row>
</template>
<script>
import MetricKpi from '@/components/reports/MetricKpi'
import MetricGraph from '@/components/reports/MetricGraph'
import MetricTable from '@/components/reports/MetricTable'

export default {
  components: {
    MetricKpi,
    MetricGraph,
    MetricTable
  }
}
</script>
